import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/subscriptions`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('auth_token') || ''}` } });

export const ArtistPlanPanel = () => {
  const [members, setMembers] = useState([]);
  const [err, setErr] = useState('');
  const load = () => axios.get(`${API}/admin/members`, auth()).then(r => { setMembers(r.data); setErr(''); })
    .catch(e => setErr([401, 403].includes(e.response?.status) ? 'Log in with your admin account (top-right menu) to see members.' : 'Could not load members'));
  useEffect(() => { load(); }, []);

  const use = async (email, item) => {
    try {
      await axios.post(`${API}/admin/members/${encodeURIComponent(email)}/use`, { item }, auth());
      toast.success('Marked as used');
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed');
    }
  };

  return (
    <div data-testid="artist-plan-admin-panel" className="space-y-4">
      <h2 className="text-xl font-bold text-white">Artist Plan Members</h2>
      {err && <p data-testid="artist-plan-admin-error" className="text-amber-300 text-sm">{err}</p>}
      {!err && members.length === 0 && <p className="text-gray-400 text-sm">No members yet. Share yoursite.com/artist-plan</p>}
      {members.map(m => (
        <div key={m.email} data-testid={`artist-plan-member-${m.email}`} className="rounded-xl border border-yellow-400/30 bg-white/5 p-4">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div>
              <div className="font-semibold text-white">{m.name || m.email}</div>
              <div className="text-xs text-gray-400">{m.email} · {m.cancel_at_period_end ? 'ending' : m.status} · {m.paid_months || 0} month{(m.paid_months || 0) === 1 ? '' : 's'} paid · payment {m.last_payment_status || 'pending'}</div>
            </div>
            <div className="text-sm text-gray-200">{m.hours_left ?? 0} hrs · {m.beat_leases_left ?? 0} leases · {m.music_video_chosen ? 'MV used' : `${m.reels_left ?? 0} reel${m.reels_left === 1 ? '' : 's'}`}</div>
          </div>
          <div className="flex flex-wrap gap-2 mt-3">
            <button data-testid={`admin-use-lease-${m.email}`} disabled={!m.beat_leases_left} onClick={() => use(m.email, 'beat_lease')} className="px-3 py-1 text-xs rounded-full bg-purple-600/40 hover:bg-purple-600/70 text-white transition-colors disabled:opacity-30">Beat lease delivered</button>
            <button data-testid={`admin-use-reel-${m.email}`} disabled={!m.reels_left || m.music_video_chosen} onClick={() => use(m.email, 'reel')} className="px-3 py-1 text-xs rounded-full bg-purple-600/40 hover:bg-purple-600/70 text-white transition-colors disabled:opacity-30">Reel delivered</button>
            <button data-testid={`admin-use-mv-${m.email}`} disabled={m.music_video_chosen || m.reels_left < 2} onClick={() => use(m.email, 'music_video')} className="px-3 py-1 text-xs rounded-full bg-purple-600/40 hover:bg-purple-600/70 text-white transition-colors disabled:opacity-30">Music video instead of reels</button>
          </div>
        </div>
      ))}
    </div>
  );
};
